import { createAction } from '@reduxjs/toolkit';

export const exportLexiconContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('ExportLexiconContainer/NavigateTo'),
};
